export default __webpack_public_path__ + "static/media/sy-szsj.403c8085.png";